<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h5 class="txt-dark">
            Asset Groups
            <add-button link="/settings/asset-groups/create"></add-button>
            <refresh-button @click="getData"></refresh-button>
          </h5>
          <my-search :search="search" placeholder="Search value..." @searchData="searchData"></my-search>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Asset Groups</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="5"></loading-table>
                      <router-link 
                        v-for="(assetGroup, at) in assetGroups"
                        :key="`assetGroup${at}`"
                        :to="`/settings/asset-groups/${assetGroup.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ assetGroup.name }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'ClassSocieties',
  data () {
    return {
      assetGroups: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      search: '',
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page = 1, search = '') {
      this.isLoading = true
      let assetGroups = await axios.get(`/asset_groups?page=${page}&rowsPerPage=${this.rowsPerPage}&search=${search}`)
      this.assetGroups = assetGroups.data.data
      this.count = assetGroups.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    },
    searchData(value) {
      this.getData(1, value)
    }
  }
}
</script>

<style>


th {
  
}
</style>